import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs';
import { PageCategoryCO, PageCategoryType, PageCO } from 'src/app/shared/models/ApiModels';
import { PageDataService } from 'src/app/shared/services/page-data.service';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { MatDialog } from '@angular/material/dialog';
import { GalleryViewerComponent } from './gallery-viewer/gallery-viewer.component';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  loading$ = this.pageDataService.loading$;
  error$ = this.pageDataService.error$;

  culturalImages: string[] = [];
  sportsImages: string[] = [];
  celebrationImages: string[] = [];

  constructor(
    private pageDataService: PageDataService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.pageDataService.loadPageData();
  }

  pageData$ = this.pageDataService.pageData$.pipe(
    tap(data => {
      if (data?.length) {
        this.extractImages(data[1]);
      }
    })
  );

  private extractImages(page: PageCO): void {
    if (!page.category?.length) return;

    const categoryMap = new Map<PageCategoryType, PageCategoryCO>();
    page.category.forEach(cat => categoryMap.set(cat.category, cat));

    this.culturalImages = this.buildImageList(
      categoryMap.get(PageCategoryType.CulturalActivities)
    );

    this.sportsImages = this.buildImageList(
      categoryMap.get(PageCategoryType.Sports)
    );

    this.celebrationImages = this.buildImageList(
      categoryMap.get(PageCategoryType.SchoolCelebration)
    );
    console.log(this.sportsImages)
  }

  private buildImageList(category?: PageCategoryCO): string[] {
    return (
      category?.image?.map(img =>
        this.getFileUrl(img.file.fileUUID)
      ) ?? []
    );
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }

  openViewer(images:string[],index:number):void{
    this.dialog.open(GalleryViewerComponent,{
      panelClass:'gallery-viewer-dialog',
      backdropClass:'gallery-backdrop',
      maxWidth:'100vw',
      width:'100vw',
      height:'100vh',
      data:{
        images,
        index
      }
    });
  }
}
